import { queryOptions } from '@tanstack/react-query';
import { TypeService } from '@/features/types/services/TypeService.ts';

export const typeQueryKeys = {
  all: ['types'],
  list: (producerId: string) => [...typeQueryKeys.all, 'list', producerId],
};

export const typeQueries = {
  list: (producerId: string | null) =>
    queryOptions({
      queryKey: typeQueryKeys.list(producerId!),
      queryFn: () => TypeService.list(producerId!),
      enabled: !!producerId,
    }),
};
